
import Vue from 'vue';

/**
 * Button components for Eucalyptus.
 * @version 2.0.0
 */
export default Vue.extend({
  name: 'Button',
  computed: {
    /**
     * Get class computed from the props.
     */
    classes() {
      return {
        [this.type]: !this.disabled,
        [`eu-btn-${this.size}`]: true,
        rounded: this.round,
        outline: this.outline,
        block: this.block
      };
    }
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Type of button. Possible values: `primary` `secondary` `default` `destructive`
     * @values primary, secondary, default, destructive
     */
    type: {
      type: String,
      default: 'default',
      validator: value => ['primary', 'secondary', 'default', 'destructive'].includes(value)
    },
    /**
     * Make button round on edge.
     */
    round: {
      type: Boolean,
      default: false
    },
    /**
     * Make button outline (white background).
     */
    outline: {
      type: Boolean,
      default: false
    },
    /**
     * Make button disabled.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Make button fit to its parent width.
     */
    block: {
      type: Boolean,
      default: false
    },
    /**
     * Make button loading status.
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Size of the button. Possible values: `sm` `md` `lg`
     * @values sm, md, lg
     */
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    }
  },
  methods: {
    handleClick(event: Event) {
      if (!this.loading && !this.disabled) {
        /**
         * Handle when user click the button.
         * @event click
         * @type {function}
         */
        this.$emit('click', event);
      }
    }
  }
});
